import { useLoaderData } from '@remix-run/react';
import Section from '~/components/section.tsx';
import { ContactButton } from '~/routes/contact+/components/contact-button.tsx';
import { type IndexLoaderData } from '../Types.ts';

type HeroLineProps = {
  line: string;
};

function HeroLine({ line }: HeroLineProps) {
  return (
    <span className="mb-2 text-center text-3xl last-of-type:mb-0 md:text-5xl md:font-thin lg:text-6xl">
      {line}
    </span>
  );
}

export function Hero() {
  const { hero } = useLoaderData<IndexLoaderData>();

  const lines = hero.cta.split('\n');

  return (
    <Section>
      <div className="flex h-full w-full flex-col items-center justify-center sm:m-auto sm:max-w-[1400px]">
        <img src={hero.image} alt="force builders logo" className="mb-1 md:mb-0" />
        <div className="flex flex-col items-center justify-center">
          {lines.map((line) => (
            <HeroLine key={line} line={line} />
          ))}
        </div>
        <div className="mt-5 md:mt-10">
          <ContactButton />
        </div>
      </div>
    </Section>
  );
}
